import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { findWidgetForGridSlot } from '../dashboard-layouts.utils';

import layoutStyles from '../utils/dashboard-layouts.styles';

const useStyles = makeStyles({
  ...layoutStyles,
  fullHeight: {
    maxHeight: 'none',
    height: 'calc(99vh - 98px)'
  }
});

const LayoutL = props => {
  const classes = useStyles();
  const { singleColumnWidth } = props;

  const calculateWidgetForSlot = useCallback(slot => findWidgetForGridSlot({ ...props, slot }), [
    props
  ]);

  return (
    <Grid container direction="row" justify="flex-start" alignItems="stretch" spacing={0}>
      <Grid item md={singleColumnWidth} className={`${classes.tableColumn} ${classes.fullHeight}`}>
        {calculateWidgetForSlot(0)}
      </Grid>
    </Grid>
  );
};

LayoutL.propTypes = {
  singleColumnWidth: PropTypes.number
};

LayoutL.defaultProps = {
  singleColumnWidth: 12
};

export default LayoutL;
